import { REACT_APP_API_ABM_FW } from '../../../common/config';
import axios from "axios";

export async function getPayCompany() {
  const response = await axios.get(`${REACT_APP_API_ABM_FW}/pagos/companies`)

  return response.data
}